import statusStore from "../../stores/statusStore";
import activityLogStore from "../../stores/activityLogStore";

export default function StatusDropdown({selectedShow, currentStatus, statusDDOpen, setStatusDDOpen}) {
    
    const staStore = statusStore();
    const actStore = activityLogStore();

    const endedOptions = [
        "Started",
        "To Watch",
        "Stopped",
        "Finished",
        "Not Interested"
    ];
    const continuingOptions = [
        "Started",
        "To Watch",
        "Stopped",
        "Finished what's available",
        "Not Interested"
    ];

    const handleSelect = async (value, airingStatus) => {
        setStatusDDOpen(false);
        await staStore.updateSeriesStatus(selectedShow._id, value, airingStatus);
        await staStore.fetchStatus();
        
        await actStore.createActivityLog(selectedShow._id, value); 
    };

    return (
        <div>
            {selectedShow.airingStatus==="Ended" && <div class="dropdown">
                <button type="button" onClick={() => setStatusDDOpen(!statusDDOpen)} className="statusDropdown" > 
                    {currentStatus || "Select status..."}
                    <img className="chevronIcon" src="/assets/icons/chevron-down-black.png"></img>
                </button>
                {statusDDOpen && (             
                    <ul className="statusDropdownMenu">
                    {endedOptions.map((option) => (
                        <li
                        key={option}
                        className={`dropdown-item ${option === currentStatus ? "selected" : ""}`}
                        onClick={() => handleSelect(option, selectedShow.airingStatus)}
                        >
                        {option}
                        </li>
                    ))}
                    </ul>
                )}
            </div>}
            {selectedShow.airingStatus==="Continuing" && <div class="dropdown">
                <button type="button" onClick={() => setStatusDDOpen(!statusDDOpen)} className="statusDropdown" > 
                    {currentStatus || "Select status..."}
                    <img className="chevronIcon" src="/assets/icons/chevron-down-black.png"></img>
                </button>
                {statusDDOpen && (
                    <ul className="statusDropdownMenu">
                    {continuingOptions.map((option) => (
                        <li
                        key={option}
                        className={`dropdown-item ${option === currentStatus ? "selected" : ""}`}
                        onClick={() => handleSelect(option, selectedShow.airingStatus)}
                        >
                        {option}
                        </li>
                    ))}
                    </ul>
                )}
            </div>}

        </div>
    )
}